@if (showAboutThisPage) {
  <div class="onboarding-page-overlay"></div>
}

<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [customBack]="backPage"
      [title]="'Bills'"
      [showLinkIcon]="true"
      [linkIcon]="'settings-outline'"
      (linkAction)="goToBillSettingsPage()"
      [disabledLinkAction]="showAboutThisPage" />
  }
</ng-template>

<ng-container
*ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [isPrimaryLayer]="true" [ngClass]="{'flex-content': windowService.isDesktopRes}">

    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    <!-- Shared filter menu for desktop and mobile -->
    <mat-menu #menu="matMenu" class="filter-menu">
      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
        <mat-tree-node *matTreeNodeDef="let node">
          <button mat-menu-item matTreeNodeToggle class="tree-node-padding">
            <mat-checkbox
              class="checkbox"
              [checked]="getNodeChecked(node)"
              (click)="$event.stopPropagation()"
              (change)="checkNode(node, $event)">
              {{ node.name | titlecase | translate }}
            </mat-checkbox>
          </button>
        </mat-tree-node>
        <mat-tree-node
          *matTreeNodeDef="let node; when: hasChild">
          <button
            class="node-button-padding"
            mat-menu-item
            matTreeNodeToggle
            [attr.aria-label]="'Toggle ' + node.name">
            <mat-icon class="mat-icon-rtl-mirror">
              {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
            {{ node.name | titlecase | translate }}
          </button>
        </mat-tree-node>
      </mat-tree>
    </mat-menu>

    @if (windowService.isDesktopRes) {
      <tidy-desktop-header>
        <div class="wrappable-container allow-wrap">
          <tidy-text
            [title]="'Bills'" />
          <form [formGroup]="form" novalidate action="#" class="form-filters">
            <tidy-header-datepicker
              (customDateOption)="selectCustomDateRange($event)"
              (stringDateOption)="selectStringDateRange($event)"
              [(dateRangeForm)]="dateRangeForm"
              [selectOptions]="selectOptions"
              [header]="true" />
          </form>
          <tidy-small-button
            [text]="'Filter'"
            [image]="'assets/img/filter-white.svg'"
            [matMenuTriggerFor]="menu"
            [matMenuTriggerDisabled]="showAboutThisPage"
            [matMenuTriggerData]="{closeDisabled: true}" />
          <tidy-small-button
            [text]="'Create Invoice'"
            [image]="'assets/img/add-button-white.svg'"
            (buttonClick)="goToCreateInvoice()" />
          <tidy-image
            [src]="'assets/img/download_csv.svg'"
            class="desktop-header-icon secondary-text-icon"
            (action)="exportCSV()"/>
          <tidy-image
            [src]="'assets/img/gear.svg'"
            class="desktop-header-icon secondary-text-icon"
            (action)="goToBillSettingsPage()"/>
          @for (chip of chips; track chip) {
            <ion-chip class="filter-chip">
              @if (chip.icon) {
                <mat-icon
                  class="chip-icon"
                  [style.color]="chip.color || 'inherit'">{{ chip.icon }}</mat-icon>
              }
              <ion-label>{{ chip.name | titlecase | translate }}</ion-label>
              <ion-icon name="close-circle" (click)="removeChip(chip)" />
            </ion-chip>
          }
        </div>
        <div class="non-wrappable-right-aligned-container">
          @if (showLoadingSpinner) {
            <ion-spinner name="lines" class="header-loading-spinner" style="margin-right: 15px" />
          }
          <!-- <automations-preview-button
            [sectionName]="'Bills'" /> -->
        </div>
      </tidy-desktop-header>
      <!-- Skeleton table while loading — rows float in with the entrance cascade;
           the real table below then replaces it in place, instantly (skipEntrance). -->
      @if (!isDataLoaded) {
        <tidy-table
          [skeletonLoading]="true"
          [columnslabels]="headers" />
      }
      @if (isDataLoaded) {
        <div class="desktop-flex-fill">
          <tidy-table
            #tidyTable
            [dataSource]="currentRows"
            [displayedColumns]="headers"
            [columnslabels]="headers"
            [allRowIsClickable]="true"
            [rowsToShow]="25"
            [showColumnLines]="false"
            (sortChange)="sortChanged($event)"
            (cellClick)="onTableColumnClick($event)"
            (pageChange)="pageChange($event)"
            [infiniteScroll]="true"
            [totalRows]="totalRows"
            [skipEntrance]="true"
            [blockSorting]="true" />
        </div>
      }
    }

    @if (!windowService.isDesktopRes) {
      @if (!isDataLoaded) {
        <div style="width: 100%">
          <ion-skeleton-text
            animated="true"
          style="height: 75px; border-radius: 6px" />
        </div>
        <div style="width: 100%; padding-top: 1rem;">
          <ion-skeleton-text
            animated="true"
          style="height: 200px; border-radius: 6px" />
        </div>
        <div style="width: 100%;">
          <ion-skeleton-text
            animated="true"
          style="height: 200px; border-radius: 6px" />
        </div>
        <div style="width: 100%;">
          <ion-skeleton-text
            animated="true"
          style="height: 200px; border-radius: 6px" />
        </div>
      }
      @if (isDataLoaded) {
          <div class="mobile-filter-row">
            <form [formGroup]="form" novalidate action="#">
              <tidy-header-datepicker
                (customDateOption)="selectCustomDateRange($event)"
                (stringDateOption)="selectStringDateRange($event)"
                [(dateRangeForm)]="dateRangeForm"
                [selectOptions]="selectOptions"
                [header]="true" />
            </form>
            <tidy-small-button
              class="mobile-filter-button"
              [iconOnly]="true"
              [image]="'assets/img/filter-white.svg'"
              [matMenuTriggerFor]="menu"
              [matMenuTriggerDisabled]="showAboutThisPage" />
          </div>
        @if (chips.length > 0) {
          <div class="mobile-filter-chips">
            @for (chip of chips; track chip) {
                <ion-chip class="filter-chip">
                  @if (chip.icon) {
                    <mat-icon
                      class="chip-icon"
                      [style.color]="chip.color || 'inherit'">{{ chip.icon }}</mat-icon>
                  }
                  <ion-label>{{ chip.name | titlecase | translate }}</ion-label>
                  <ion-icon name="close-circle" (click)="removeChip(chip)" />
                </ion-chip>
            }
          </div>
        }
      }
      @for (bill of bills; track bill) {
        <tidy-card>
          <tidy-card-button
            (action)="goToInvoicePage(bill)"
            class="arrow-to-top">
            <tidy-row>
              <tidy-grid>
                <tidy-row>
                  <ion-row>
                    <ion-col size="6">
                      <tidy-row>
                        <tidy-text
                          [title]="bill?.homekeeper_data?.name | titlecase"
                          [translate]="false" />
                      </tidy-row>
                    </ion-col>
                  </ion-row>
                </tidy-row>
              </tidy-grid>
            </tidy-row>
          </tidy-card-button>
          <div style="position: absolute; left: 0; right: 0; height: 7px; background: #275C7C;"></div>
          <tidy-row class="extra-top-padding" [alignLastItemRight]="true">
            <tidy-text [body]="'Service'" />
            <tidy-text [body]="'Owed'" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding">
            <tidy-divider />
          </tidy-row>
          @for (service of bill?.items; track service; let last = $last) {
            <tidy-row [alignLastItemRight]="true">
              <div style="width: 85%">
                <tidy-text
                  [header]="service?.service_details?.name | titlecase" />
              </div>
              <div>
                @if (service?.amount) {
                  <tidy-text
                    [body]="service?.amount | tcurrency" />
                }
                @if (!service?.amount) {
                  <tidy-text
                    [body]="bill?.amount | tcurrency" />
                }
              </div>
            </tidy-row>
            <tidy-row>
              <tidy-text
              [body]="(service?.service_details?.date | parseDateTime:'MMM d') +
                ' at ' +
                service?.service_details?.address?.address +
                ', ' +
                (service?.service_details?.address?.unit ? ('Unit ' + service?.service_details?.address?.unit + ', ') : '') +
                service?.service_details?.address?.zip"
                [translate]="false" />
            </tidy-row>
            <tidy-row
              class="extra-top-padding"
              [ngClass]="last ? '' : 'extra-bottom-padding'">
              <tidy-divider />
            </tidy-row>
          }
          @if (!bill.full_paid) {
            @if (bill.amount - bill.amount > 0) {
              <tidy-row
                [alignLastItemRight]="true"
                class="extra-top-padding"
                >
                <tidy-text [header]="'Credit Applied'" />
                <tidy-text [body]="bill.amount - bill.amount | tcurrency" />
              </tidy-row>
            }
            <tidy-row [alignLastItemRight]="true" class="extra-top-padding">
              <tidy-text [header]="'Total'" />
              <tidy-text
                [body]="'<b>' + (bill?.amount | tcurrency) + '</b>'" />
            </tidy-row>
          }
          @if (bill.full_paid) {
            <tidy-row [alignLastItemRight]="true" class="extra-top-padding">
              <tidy-text [header]="'Total'" />
              <tidy-text [body]="'<b>' + (bill?.amount | tcurrency) + '</b>'" />
          </tidy-row>
        }
      </tidy-card>
    }
    @if (bills?.length && bills.length < totalRows) {
      <ion-infinite-scroll (ionInfinite)="handleInfiniteScroll($event)">
        <ion-infinite-scroll-content
          loadingSpinner="bubbles"
          loadingText="Loading more bills..." />
      </ion-infinite-scroll>
    }
    @if (!bills?.length && isDataLoaded) {
      <tidy-alert>
        <tidy-row>
          <tidy-text [body]="getEmptyStateMessage()" />
        </tidy-row>
      </tidy-alert>
    }
  }

</tidy-wrapper>
</ng-template>

<app-scroll-wrapper
  [isfullWidthContent]="true"
  [templateContent]="content" />


@if (showAboutThisPage) {
  <tidy-about-this-page [page]="'bills'" (dismissed)="dismissAboutThisPage()" />
}